import { styled } from '@mui/system'
import { FULL_VIDEO_VIEW_HEIGHT } from '../../../Constant/video'
import { colors, fontSizes } from '../../../Components/consts'

export const VideoElement = styled('div', {
  shouldForwardProp: (prop) => prop !== '$videoWidth',
})<{ $videoWidth?: string }>(({ $videoWidth }) => ({
  width: $videoWidth ?? '100%',
  maxWidth: '100%',
  display: 'block',
}))

export const VideoErrorContainer = styled('div')(() => ({
  width: '100%',
  height: `${FULL_VIDEO_VIEW_HEIGHT}vh`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.white,
  background: colors.black,
  fontSize: fontSizes.medium,
}))

export const VideoContainer = styled('div')(() => ({
  position: 'relative',
}))

export const videoElementStyle = (videoWidth: string) => ({
  width: videoWidth,
  maxWidth: '100%',
  display: 'block',
})
